import { useState } from 'react'
import {
  Box, Button, Menu, MenuItem, ListItemIcon, ListItemText, Typography, Badge, Divider, Chip,
} from '@mui/material'
import { Lock, ForkRight, KeyboardArrowDown } from '@mui/icons-material'
import StatusBadge from '../common/StatusBadge'

export default function PlanSelector({ plans, activePlan, scenarios, onSelectPlan, onSelectScenario, activeScenario }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const approved = plans.find((p) => p.status === 'Approved')
  const currentLabel = activeScenario
    ? activeScenario.name
    : activePlan?.name || 'Select Plan'

  return (
    <>
      <Button
        variant="outlined"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        endIcon={<KeyboardArrowDown />}
        sx={{
          textTransform: 'none',
          justifyContent: 'flex-start',
          minWidth: 280,
          py: 1,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, textAlign: 'left' }}>
          {activeScenario ? (
            <ForkRight sx={{ fontSize: 20, color: 'warning.main' }} />
          ) : (
            <Lock sx={{ fontSize: 20, color: 'primary.main' }} />
          )}
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" noWrap>{currentLabel}</Typography>
            {activeScenario && (
              <Typography variant="caption" color="text.secondary">
                Scenario &middot; {activePlan?.name}
              </Typography>
            )}
          </Box>
          <Badge
            badgeContent={scenarios.length}
            color="warning"
            sx={{ mr: 1 }}
          />
        </Box>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        PaperProps={{ sx: { minWidth: 320, maxHeight: 400 } }}
      >
        {approved && (
          <MenuItem
            selected={activePlan?.id === approved.id && !activeScenario}
            onClick={() => { onSelectPlan(approved); onSelectScenario?.(null); setAnchorEl(null) }}
          >
            <ListItemIcon><Lock sx={{ color: 'primary.main' }} /></ListItemIcon>
            <ListItemText
              primary={approved.name}
              secondary="Approved Plan"
            />
            <StatusBadge status="APPROVED" />
          </MenuItem>
        )}

        {scenarios.length > 0 && <Divider />}

        {scenarios.length > 0 && (
          <Box sx={{ px: 2, py: 0.5 }}>
            <Typography variant="overline" color="text.secondary">
              Scenarios ({scenarios.length})
            </Typography>
          </Box>
        )}

        {scenarios.map((s) => (
          <MenuItem
            key={s.id}
            selected={activeScenario?.id === s.id}
            onClick={() => { onSelectScenario(s); setAnchorEl(null) }}
          >
            <ListItemIcon><ForkRight sx={{ color: 'warning.main' }} /></ListItemIcon>
            <ListItemText
              primary={s.name}
              secondary={`by ${s.createdBy}`}
            />
            <StatusBadge status={s.status} />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
